import { useEffect, useMemo, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { evaluatePollerHealth } from '../utils/pollerHealth';

const RE_EVALUATE_EVERY_MS = 60 * 1000;

// Live view of systemHealth/scheduledPoller. Re-evaluates once a minute as
// well as on every write, because staleness is about the CLOCK moving, not
// the document changing: a poller that stopped writing never triggers a
// snapshot, and that is precisely the case this exists to surface.
export function usePollerHealth(enabled = true) {
  const [data, setData] = useState(undefined); // undefined = not loaded yet
  const [error, setError] = useState(null);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!enabled) return undefined;
    const unsubscribe = onSnapshot(
      doc(db, 'systemHealth', 'scheduledPoller'),
      snapshot => { setData(snapshot.exists() ? snapshot.data() : null); setError(null); },
      err => { setError(err); setData(null); }
    );
    const timer = setInterval(() => setNow(Date.now()), RE_EVALUATE_EVERY_MS);
    return () => { unsubscribe(); clearInterval(timer); };
  }, [enabled]);

  const loaded = data !== undefined;
  const health = useMemo(
    () => (loaded ? evaluatePollerHealth(data, now) : null),
    [data, loaded, now]
  );
  return { health, loaded, error, data };
}
